import { NgModule } from '@angular/core';
import { AppEventsApi } from './api/app-events.api';
import { AppEventsService } from './services/app-events.service';

@NgModule({
  providers: [{ provide: AppEventsApi, useClass: AppEventsService }],
})
export class AppEventsModule {}
